import {DomainEvent} from './DomainEvent';
import {DeletedEntity} from '../resources/DeletedEntity';

export class ProfileSeasonInjuryDeleted extends DomainEvent<DeletedEntity> {}
